module.exports = __webpack_public_path__ + "img/ic_village_construction.bdcca062.png";